import React from 'react';

export const SidebarLogoutIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 6.41667L19.25 11L14.6667 15.5833M19.25 11H8.25M8.25 2.75H7.15C5.60985 2.75 4.83978 2.75 4.25153 3.04973C3.73408 3.31338 3.31338 3.73408 3.04973 4.25153C2.75 4.83978 2.75 5.60985 2.75 7.15V14.85C2.75 16.3902 2.75 17.1602 3.04973 17.7485C3.31338 18.266 3.73408 18.6866 4.25153 18.9503C4.83978 19.25 5.60985 19.25 7.15 19.25H8.25"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
